import React, { useState, Children } from 'react';
import { HomeIcon, BookOpenIcon, HelpCircleIcon, GraduationCapIcon, UsersIcon, HeartIcon, SunIcon, MenuIcon, XIcon, SparklesIcon, CheckSquareIcon, CalendarIcon, ShieldIcon, BabyIcon, PlayIcon, BookIcon } from 'lucide-react';
import { CardView } from './CardView';
import { RightsComparison } from './RightsComparison';
import { Scenarios } from './Scenarios';
import { Quiz } from './Quiz';
import { ScholarOpinions } from './ScholarOpinions';
import { CoupleStories } from './CoupleStories';
import { Solutions } from './Solutions';
import { EngagedPreparation } from './EngagedPreparation';
import { EngagedChecklist } from './EngagedChecklist';
import { EngagedRights } from './EngagedRights';
import { Consultants } from './Consultants';
import { EngagementPhase } from './EngagementPhase';
import { ChildrenRights } from './ChildrenRights';
import { EducationalVideos } from './EducationalVideos';
import { MarriageTools } from './MarriageTools';
import { DonationModal } from './DonationModal';
interface DashboardProps {
  userType: 'husband' | 'wife' | 'both' | 'engaged';
  onReset: () => void;
}
export function Dashboard({
  userType,
  onReset
}: DashboardProps) {
  const [activeTab, setActiveTab] = useState(userType === 'engaged' ? 'preparation' : 'cards');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showDonationModal, setShowDonationModal] = useState(false);
  const userTypeText = userType === 'husband' ? 'الزوج' : userType === 'wife' ? 'الزوجة' : userType === 'engaged' ? 'المقبلين على الزواج' : 'الزوجين';
  const userTypeColor = userType === 'husband' ? 'text-sky-700' : userType === 'wife' ? 'text-rose-600' : userType === 'engaged' ? 'text-purple-600' : 'text-amber-600';
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setMobileMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const navItems = userType === 'engaged' ? [{
    id: 'preparation',
    label: 'الاستعداد للزواج',
    icon: <SparklesIcon className="h-5 w-5 ml-3" data-id="element-1590" />
  }, {
    id: 'engagement',
    label: 'مرحلة الخطوبة',
    icon: <HeartIcon className="h-5 w-5 ml-3" data-id="element-1591" />
  }, {
    id: 'checklist',
    label: 'قائمة التحضير',
    icon: <CheckSquareIcon className="h-5 w-5 ml-3" data-id="element-1592" />
  }, {
    id: 'rights',
    label: 'حقوق الزوجين',
    icon: <ShieldIcon className="h-5 w-5 ml-3" data-id="element-1593" />
  }, {
    id: 'videos',
    label: 'الفيديوهات التوعوية',
    icon: <PlayIcon className="h-5 w-5 ml-3" data-id="element-1594" />
  }, {
    id: 'tools',
    label: 'مكتبة الأدوات الزوجية',
    icon: <BookIcon className="h-5 w-5 ml-3" data-id="element-1595" />
  }, {
    id: 'children',
    label: 'حقوق الأبناء',
    icon: <BabyIcon className="h-5 w-5 ml-3" data-id="element-1596" />
  }, {
    id: 'consultants',
    label: 'استشاريون',
    icon: <UsersIcon className="h-5 w-5 ml-3" data-id="element-1597" />
  }, {
    id: 'scholars',
    label: 'نصائح العلماء',
    icon: <UsersIcon className="h-5 w-5 ml-3" data-id="element-1598" />
  }, {
    id: 'quiz',
    label: 'اختبر معلوماتك',
    icon: <GraduationCapIcon className="h-5 w-5 ml-3" data-id="element-1599" />
  }] : [{
    id: 'cards',
    label: 'بطاقات معرفية',
    icon: <BookOpenIcon className="h-5 w-5 ml-3" data-id="element-1600" />
  }, {
    id: 'comparison',
    label: 'مقارنة الحقوق',
    icon: <div className="h-5 w-5 ml-3" data-id="element-1601" />
  }, {
    id: 'scenarios',
    label: 'سيناريوهات واقعية',
    icon: <HelpCircleIcon className="h-5 w-5 ml-3" data-id="element-1602" />
  }, {
    id: 'videos',
    label: 'الفيديوهات التوعوية',
    icon: <PlayIcon className="h-5 w-5 ml-3" data-id="element-1603" />
  }, {
    id: 'tools',
    label: 'مكتبة الأدوات الزوجية',
    icon: <BookIcon className="h-5 w-5 ml-3" data-id="element-1604" />
  }, {
    id: 'children',
    label: 'حقوق الأبناء',
    icon: <BabyIcon className="h-5 w-5 ml-3" data-id="element-1605" />
  }, {
    id: 'quiz',
    label: 'اختبر معلوماتك',
    icon: <GraduationCapIcon className="h-5 w-5 ml-3" data-id="element-1606" />
  }, {
    id: 'scholars',
    label: 'أصوات العلماء',
    icon: <UsersIcon className="h-5 w-5 ml-3" data-id="element-1607" />
  }, {
    id: 'stories',
    label: 'يوميات زوجين',
    icon: <HeartIcon className="h-5 w-5 ml-3" data-id="element-1608" />
  }, {
    id: 'solutions',
    label: 'الحلول الهادئة',
    icon: <SunIcon className="h-5 w-5 ml-3" data-id="element-1609" />
  }, {
    id: 'consultants',
    label: 'استشاريون',
    icon: <CalendarIcon className="h-5 w-5 ml-3" data-id="element-1610" />
  }];
  return <div className="min-h-screen flex flex-col bg-amber-50" data-id="element-1611">
      <header className="bg-white shadow-md py-4 px-6 flex justify-between items-center sticky top-0 z-30" data-id="element-1612">
        <div className="flex items-center" data-id="element-1613">
          {userType === 'engaged' ? <SparklesIcon className="h-8 w-8 text-purple-600 mr-3" data-id="element-1614" /> : userType === 'wife' ? <HeartIcon className="h-8 w-8 text-rose-600 mr-3" data-id="element-1615" /> : userType === 'both' ? <HeartIcon className="h-8 w-8 text-amber-600 mr-3" data-id="element-1616" /> : <HeartIcon className="h-8 w-8 text-sky-600 mr-3" data-id="element-1617" />}
          <h1 className="text-2xl font-bold text-sky-900" data-id="element-1618">
            <span className={userTypeColor} data-id="element-1619">{userTypeText}</span>
          </h1>
        </div>
        <div className="flex items-center" data-id="element-1620">
          <button onClick={() => setShowDonationModal(true)} className="text-rose-600 hover:text-rose-700 transition-colors duration-200 text-sm md:text-base px-3 py-1 rounded-md hover:bg-rose-50 ml-3" data-id="element-1621">
            دعم المشروع
          </button>
          <button onClick={onReset} className="text-slate-600 hover:text-sky-700 transition-colors duration-200 text-sm md:text-base px-3 py-1 rounded-md hover:bg-sky-50" data-id="element-1622">
            تغيير المسار
          </button>
          <button className="md:hidden ml-4 text-slate-600 focus:outline-none" onClick={toggleMobileMenu} data-id="element-1623">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-1624" /> : <MenuIcon className="h-6 w-6" data-id="element-1625" />}
          </button>
        </div>
      </header>
      <main className="flex-1 flex flex-col md:flex-row" data-id="element-1626">
        {mobileMenuOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={toggleMobileMenu} data-id="element-1627"></div>}
        <nav className={`bg-white shadow-md md:w-64 md:sticky md:top-20 md:h-[calc(100vh-5rem)] transition-all duration-300 ease-in-out ${mobileMenuOpen ? 'fixed top-16 right-0 h-screen z-20 w-3/4 max-w-xs transform translate-x-0' : 'fixed top-16 right-0 h-screen z-20 w-3/4 max-w-xs transform translate-x-full md:transform-none'}`} data-id="element-1628">
          <div className="p-4 space-y-2 overflow-y-auto h-full" data-id="element-1629">
            {navItems.map(item => <button key={item.id} onClick={() => handleTabChange(item.id)} className={`w-full text-right py-3 px-4 rounded-md flex items-center transition-all duration-200 ${activeTab === item.id ? 'bg-sky-100 text-sky-700 shadow-sm' : 'hover:bg-gray-100'}`} data-id="element-1630">
                {item.icon}
                <span data-id="element-1631">{item.label}</span>
              </button>)}
            <div className="md:hidden mt-8 pt-6 border-t border-gray-200" data-id="element-1632">
              <button onClick={onReset} className="w-full text-right py-3 px-4 rounded-md flex items-center text-rose-600 hover:bg-rose-50" data-id="element-1633">
                <span data-id="element-1634">العودة لاختيار المسار</span>
              </button>
            </div>
          </div>
        </nav>
        <div className="flex-1 p-4 md:p-6 transition-all duration-300 ease-in-out" data-id="element-1635">
          <div className="max-w-4xl mx-auto" data-id="element-1636">
            {userType !== 'engaged' && <>
                {activeTab === 'cards' && <CardView userType={userType} data-id="element-1637" />}
                {activeTab === 'comparison' && <RightsComparison data-id="element-1638" />}
                {activeTab === 'scenarios' && <Scenarios userType={userType} data-id="element-1639" />}
                {activeTab === 'children' && <ChildrenRights data-id="element-1640" />}
                {activeTab === 'quiz' && <Quiz userType={userType} data-id="element-1641" />}
                {activeTab === 'scholars' && <ScholarOpinions userType={userType} data-id="element-1642" />}
                {activeTab === 'stories' && <CoupleStories userType={userType} data-id="element-1643" />}
                {activeTab === 'solutions' && <Solutions userType={userType} data-id="element-1644" />}
                {activeTab === 'consultants' && <Consultants userType={userType} data-id="element-1645" />}
                {activeTab === 'videos' && <EducationalVideos userType={userType} data-id="element-1646" />}
                {activeTab === 'tools' && <MarriageTools data-id="element-1647" />}
              </>}
            {userType === 'engaged' && <>
                {activeTab === 'preparation' && <EngagedPreparation data-id="element-1648" />}
                {activeTab === 'engagement' && <EngagementPhase data-id="element-1649" />}
                {activeTab === 'checklist' && <EngagedChecklist data-id="element-1650" />}
                {activeTab === 'rights' && <EngagedRights data-id="element-1651" />}
                {activeTab === 'children' && <ChildrenRights data-id="element-1652" />}
                {activeTab === 'scholars' && <ScholarOpinions userType={userType} data-id="element-1653" />}
                {activeTab === 'quiz' && <Quiz userType={userType} data-id="element-1654" />}
                {activeTab === 'consultants' && <Consultants userType={userType} data-id="element-1655" />}
                {activeTab === 'videos' && <EducationalVideos userType={userType} data-id="element-1656" />}
                {activeTab === 'tools' && <MarriageTools data-id="element-1657" />}
              </>}
          </div>
        </div>
      </main>
      <footer className="bg-white py-4 px-6 text-center text-slate-600 border-t" data-id="element-1658">
        <p className="text-sm" data-id="element-1659">
          © {new Date().getFullYear()} حقوق الزوجين في الإسلام - عبدالرحمن
          سرحان - جميع الحقوق محفوظة
        </p>
      </footer>
      <DonationModal isOpen={showDonationModal} onClose={() => setShowDonationModal(false)} data-id="element-1660" />
    </div>;
}